import { Component, OnInit, DoCheck, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { CvOrdinalLocalizePipe } from 'src/app/reusables/pipes/cv-ordinal-localize.pipe';
import { BadgeSelectorComponent } from 'src/app/reusables/badge-selector/badge-selector.component';
import { cloneDeep } from 'lodash';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';

@Component({
  selector: 'cv-configure-rewards-top-dog',
  templateUrl: './configure-rewards-top-dog.component.html',
  styleUrls: ['./configure-rewards-top-dog.component.scss']
})
export class ConfigureRewardsTopDogComponent implements OnInit, DoCheck {
  @Input() step: number;
  @Input() componentOptions: any;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();

  gs = null;
  complete: boolean = false;
  selectedRewardLevel: any = {};
  editing: boolean;
  rewardType: number;
  rewardValue: number;
  nextPlaceText: string;
  rewardLevels = [];
  showBadgeSelector: boolean;
  showRemove = [];
  modalReference: any;
  oldBadgeSelected: number = 0;
  isCxone = false;

  constructor(
    private modalService: NgbModal,
    private gamesService: GamesService,
    private dialogService: CvDialogService,
    private ordinalPipe: CvOrdinalLocalizePipe,
    private navigationService: NavigationService,
    public cvConfigurationService: CvConfigurationService,
    private customDialogService: CvCustomDialogService,
  ) {
    this.gs = this.gamesService.data;
  }

  ngOnInit(): void {
    this.gs.modified.item.TopDogRewards = this.gs.modified.item.TopDogRewards || [this._newLevelTemplate()];
    this.rewardLevels = this.gs.modified.item.TopDogRewards;
    this.nextPlaceText = this.ordinalPipe.transform(this.rewardLevels.length + 1);

    for (var i = 0; i < this.rewardLevels.length; i++) {
      this.showRemove.push(false);
    }
    this.isCxone = this.cvConfigurationService.isCxOne;
  }

  ngDoCheck(){
    if(this.selectedRewardLevel != null && this.selectedRewardLevel.Badge != null && this.selectedRewardLevel.Badge.rewardValue != this.oldBadgeSelected){
      this.oldBadgeSelected = this.selectedRewardLevel.Badge.rewardValue;
      this.checkIfComplete();
    }
  }

  _newLevelTemplate(): any {
    return {
      Coins: this._newRewardTemplate(this.gs.rewardOptions.Coins),
      XP: this._newRewardTemplate(this.gs.rewardOptions.XP),
      Currency: this._newRewardTemplate(this.gs.rewardOptions.Currency),
      Badge: this._newRewardTemplate(this.gs.rewardOptions.Badge)
    };
  }

  _newRewardTemplate(type: number): any {
    return {
      editing: false,
      rewardType: type,
      rewardValue: 0
    }
  }

  openMoreLevelsInfoBox(modalTemplate): void {
    this.navigationService.showOverlay = true;
    this.modalReference = this.modalService.open(modalTemplate, {
      animation: true,
      backdropClass: 'stopScrolling',
      size: 'md-lg modal-dialog-noborder-when-loading modal-dialog-centered'
    });

    this.modalReference.result.finally(() => {
      this.navigationService.showOverlay = false;
    });
  }

  goToRules(): void {
    window.open(_BaseURI + "/Goals/Rules.aspx", "_blank");
  }

  closeModalInfo(): void {
    this.navigationService.showOverlay = false;
    this.modalReference.close();
  }

  addNewLevel(): void {
    this.rewardLevels.push(this._newLevelTemplate());
    this.nextPlaceText = this.ordinalPipe.transform(this.rewardLevels.length + 1);
  }

  removeRewardLevel(rewardLevel, $index): void {
    if (rewardLevel.RuleLevelID > 0) { //already saved to db
      if (this.gs.modified.item.RemovedRuleLevelIDs == null)
        this.gs.modified.item.RemovedRuleLevelIDs = [];
      this.gs.modified.item.RemovedRuleLevelIDs.push(rewardLevel.RuleLevelID);
    }

    this.rewardLevels.splice(this.rewardLevels.indexOf(rewardLevel), 1);
    this.nextPlaceText = this.ordinalPipe.transform(this.rewardLevels.length + 1);
  }

  confirmRemoveLevel(rewardLevel, $index) {
    if (this.rewardLevels == null || this.rewardLevels.length < 2) {
      const errorMessage = this.gamesService.getLocalizedMessage("Top_Dog_Remove_Level_Failed", "Cannot remove the last reward level in this game.");
      const errorTitle = this.gamesService.getLocalizedMessage("Action_Not_Allowed", "Action Not Allowed");
  
      if (this.cvConfigurationService.isCxOne) {
        const modalOptions: NgbModalOptions = {
          keyboard: false,
          backdrop: 'static',
          centered: true,
          windowClass: 'cxone-create-game-validation-modal'
        };

        this.customDialogService.showDialog(
          this.gamesService.getLocalizedMessage("Action_Not_Allowed", "Action Not Allowed"),
          this.gamesService.getLocalizedMessage("Top_Dog_Remove_Level_Failed", "Cannot remove the last reward level in this game."),
          13,
          '',
          this.gamesService.getLocalizedMessage("Ok", "Ok"),
          true,
          () => {},
          () => {},
          'cxone-create-game-validation-modal-style',
          true,
          modalOptions
        );
      } else {
        showErrorMessage(errorMessage, errorTitle);
      }
      return;
    }
  
    const title = this.gamesService.getLocalizedMessage("Confirm_Remove", "Confirm Remove");
    const message = this.gamesService.getLocalizedMessage("Remove_TopDog_Level", "Are you sure you want to remove this level? This operation cannot be undone.");
  
    if (this.cvConfigurationService.isCxOne) {
      const modalOptions: NgbModalOptions = {
        keyboard: false,
        backdrop: 'static',
        centered: true,
        windowClass: 'cxone-create-warning-modal'
      };
  
      const okLabel = this.gamesService.getLocalizedMessage("Ok", "Ok");
      const cancelLabel = this.gamesService.getLocalizedMessage("Cancel", "Cancel");
  
      this.customDialogService.showDialog(
        title,
        message,
        11, // Confirm dialog type
        cancelLabel,
        okLabel,
        true,
        () => { this.removeRewardLevel(rewardLevel, $index); },
        () => {}, // No action on cancel
        'cxone-modal-game-warning',
        true,
        modalOptions
      );
    } else {
      this.dialogService.showConfirmDialog(
        title, message, false, () => { this.removeRewardLevel(rewardLevel, $index); }
      );
    }
  }
  popBadgeSelector(rewardLevel: number): void {
    this.showBadgeSelector = true;
    this.selectedRewardLevel = rewardLevel;

    const modalRef = this.modalService.open(BadgeSelectorComponent, {
      animation: true,
      backdropClass: 'stopScrolling',
      size: 'md-lg modal-dialog-noborder-when-loading modal-dialog-centered'
    });

    //Sending input value
    modalRef.componentInstance.header = this.gamesService.getLocalizedMessage("Select_Badge", "Select your badge");
    modalRef.componentInstance.showWhen = this.showBadgeSelector;
    modalRef.componentInstance.showCustomBadge = !this.isCxone;

    //Catching event answer
    modalRef.componentInstance.onBadgeSelected.subscribe(result => {
      this.selectedRewardLevel.Badge.rewardValue = result;
      modalRef.close();
    });
  }

  removeBadge(badge): void {
    badge.rewardValue = 0;
  }

  getPopoverTemplate(badgeID: number): string {
    return "<div class='glaeBadgePopover'><img src=\"../Admin/ImageResizer.aspx?imgid=" + badgeID + "&w=128&h=128\" /></div>"
  }

  handleRewardBlur($event) {
    var $elem = $($event.target);
    var resetToZero = false; //If the box is empty or invalid, should the value reset to zero?
    if ($elem != null) {
      var val = parseFloat($elem[0].value);
      if (val == null || isNaN(val)) {
        resetToZero = true;
      }
    }

    if (resetToZero) {
      $elem[0].value = 0;
    }

    this.checkIfComplete();
  };

  checkIfComplete() {
    if (!this.complete) {
      //check each level and if anything is set at all, set complete to true
      if (this.rewardLevels != null) {
        for (var i = 0; i < this.rewardLevels.length; i++) {
          if (this.rewardLevels[i].Coins.rewardValue > 0 || this.rewardLevels[i].XP.rewardValue > 0 || this.rewardLevels[i].Currency.rewardValue > 0 || this.rewardLevels[i].Badge.rewardValue > 0) {
            this.complete = true;

            //Fire one time event to unlock the next component
            var eventArgs = {
              currentStep: this.step - 1,
              unlocks: this.componentOptions.unlocks
            };

            this.componentComplete.emit(eventArgs);
          }
        }
      }
    }
  }
}
